/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PreviousDamages } from './previousDamages';

/**
 * Represents a private liability insurance.   (german: Privathaftpflicht)   (bipro-versicherung-haftpflicht::Privat)
 */
export interface PreviousPrivateLiabilityInsurance {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  damages?: PreviousDamages;
}
